import { useQuery } from '@tanstack/react-query';
import {
  getDashboardMetrics,
  getActiveUsersWindows,
  getFirebaseAnalytics,
  getDeviceActivity,
  getErrorsByType,
  getRecentDevices,
} from '@/api/endpoints/dashboard';
import type { ActivityPeriod } from '@/api/endpoints/dashboard';

export const useDashboardMetrics = () => {
  return useQuery({
    queryKey: ['dashboard', 'metrics'],
    queryFn: getDashboardMetrics,
    staleTime: 1000 * 60,
    retry: 1,
    refetchInterval: 1000 * 60 * 2,
  });
};

export const useActiveUsersWindows = () => {
  return useQuery({
    queryKey: ['dashboard', 'active-users'],
    queryFn: getActiveUsersWindows,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};

export const useFirebaseAnalytics = () => {
  return useQuery({
    queryKey: ['dashboard', 'firebase-analytics'],
    queryFn: getFirebaseAnalytics,
    staleTime: 1000 * 60 * 10,
    retry: 1,
  });
};

export const useDeviceActivity = (period: ActivityPeriod = '7d') => {
  return useQuery({
    queryKey: ['dashboard', 'device-activity', period],
    queryFn: () => getDeviceActivity(period),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};

export const useErrorsByType = () => {
  return useQuery({
    queryKey: ['dashboard', 'errors-by-type'],
    queryFn: getErrorsByType,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};

export const useRecentDevices = (limit = 10) => {
  return useQuery({
    queryKey: ['dashboard', 'recent-devices', limit],
    queryFn: () => getRecentDevices(limit),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};
